import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2d5c8534&scoped=true"
import script from "./NotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2d5c8534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c8534",
  null
  
)

export default component.exports